import React, { useState, useCallback } from "react";
import { Box, Divider } from "@mui/material";
import Header from "../Components/Header/Header";
import SectionTitle2 from "../Components/Ui-Components/SectionTitle2/SectionTitle2";
import { useSelector } from "react-redux";

// Import the components
import EventCertificateManager from "./EventCertificateManager";
import EventManager from "./EventManager";
import { useLocation } from "react-router-dom";

const  CertificateMainPage= () => {
  const [currentFlow, setCurrentFlow] = useState("search");
  const [certificateData, setCertificateData] = useState(null);
  const [resumeSelection, setResumeSelection] = useState(false);
  const state = useSelector((state) => state.shop.products);
  const { states } = useLocation();
  const { eventName, bibNumber } = states || {};

  // Handle when user proceeds from EventCertificateManager to certificate generation
  const handleProceedToCertificate = useCallback((data) => {
    setCertificateData(data);
    setCurrentFlow("certificate");
    setResumeSelection(false);
  },[]);

  // Handle going back to search from certificate flow
  const handleBackToSearch = () => {
    setCurrentFlow("search");
    setCertificateData(null);
    setResumeSelection(false);
  };

  const handleBackToImageSelection = () => {
    setResumeSelection(true); 
    setCurrentFlow("search");
  };
  // Handle closing the entire flow (redirect to home or wherever needed)
  const handleClose = () => {
    console.log("Closing Event Certificate flow");
    setCurrentFlow("search");
    setCertificateData(null);
    setResumeSelection(false);
  };

  return ( 
    <Box sx={{ height: '100%', minHeight: '100vh' }}>
      <Header />
  
      {currentFlow === "search" ? (
        <EventCertificateManager
          onClose={handleClose}
          onProceedToCertificate={handleProceedToCertificate}
          resumeSelection={resumeSelection}
          certificateData={certificateData}
        />
      ) : (
        <EventManager
          onClose={handleBackToSearch}
          certificateData={certificateData}
          onBackToSelection={handleBackToImageSelection}
        />
      )}
    </Box>
  );
};

export default CertificateMainPage;